import * as CheckoutAPIActions from '../../v2/actions/APIActions/CheckoutAPIActions';
import setNewpaySessionData from '../../v2/actions/paymentActions/newpay/setNewpaySessionData';
import setNewpayWallet from '../../v2/actions/paymentActions/newpay/setNewpayWallet';
import Track from '../../v2/utils/tracking';

const getNewpayDetails = () => dispatch => dispatch(CheckoutAPIActions.getPaymentSessionDetails('newpay', {paymentMethod: 'NEWPAY'}))
  .then((response) => {
    if (response.status === 200 && response.msg) {
      const wallet = window.dekoWallet.init(() => Promise.resolve(response.msg.initToken));
      wallet.hide();
      dispatch(setNewpaySessionData(response.msg));
      dispatch(setNewpayWallet(wallet));
    } else {
      Track.error(`Error getting Newpay session data from Checkout API: response: ${JSON.stringify(response)}`);
    }
  }).catch((e) => {
    Track.error(`Error setting Newpay session data: ${e}`);
  });

export default getNewpayDetails;
